<template>
  <div :class="[keyboardClass, {disabled: disabled}]"></div>
</template>

<script>
import Keyboard from "simple-keyboard";

export default {
  name: "SimpleKeyboard",
  props: {
    keyboardClass: {
      default: "simple-keyboard",
      type: String
    },
    input: {
      type: String
    }
  },
  data: () => ({
    keyboard: null,
    disabled: false,
  }),
  mounted() {
    this.keyboard = new Keyboard(this.keyboardClass, {
      useButtonTag: false,
      activeButtonClass: '',
      onChange: this.onChange,
      onKeyPress: this.onKeyPress,
      disableCaretPositioning: true,
      layout: {
        default: ["1 2 3", "4 5 6", "7 8 9", "{shift} 0 {bksp}", "{enter}"],
      },
      display: {
        '{bksp}': 'BACKSPACE',
        '{shift}': 'SHIFT',
        '{enter}': 'OK',
      },
      theme: "hg-theme-default hg-layout-numeric numeric-theme",
      buttonTheme: [
        {
          class: "btn numpad-button",
          buttons: "1 2 3 4 5 6 7 8 9 {shift} 0 {bksp} "
        },
        {
          class: "btn numpad-button",
          buttons: "{enter} "
        },
      ]
    });
    window.events.$on('disableNumpad', value => {
      this.disabled = true;
    });

    window.events.$on('enableNumpad', value => {
      this.disabled = false;
      this.keyboard.setInput('');
    });

  },

  beforeDestroy () {
    window.events.$off('disableNumpad');
    window.events.$off('enableNumpad');
  },
  methods: {
    onChange(input) {
      if (!this.disabled) {
        this.$emit("onChange", input);
      }
    },
    onKeyPress(button) {
      if (!this.disabled) {
        this.$emit("onKeyPress", button);
      }

    },
  },

  watch: {
    input(input) {
      this.keyboard.setInput(input);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.hg-button[disabled] {
  pointer-events: none;
}
</style>
